/**
 * Helper per il badge "Cessato" del lavoratore in tabella + dettaglio.
 *
 * Regola: il badge globale appare solo se TUTTE le posizioni presenti
 * del lavoratore hanno stato='C'. Se anche una sola cassa è attiva, il
 * badge non appare (lo stato per-cassa resta visibile nei pipottini).
 * Coerente con bergamo legacy commit 2741d7e (AND tra le casse).
 */

export interface PosizioneRaw {
  stato?: string;
  dataCessazione?: string | null;
}

export interface CessatoInfo {
  dataCessazione: string | null;
}

export function buildCessatoInfo(posizioni: Record<string, PosizioneRaw> | undefined): CessatoInfo | null {
  if (!posizioni) return null;
  const values = Object.values(posizioni).filter((p): p is PosizioneRaw => Boolean(p));
  if (values.length === 0) return null;
  if (!values.every(p => p.stato === 'C')) return null;
  const withDate = values.find(p => p.dataCessazione);
  return { dataCessazione: withDate?.dataCessazione ?? null };
}

/**
 * Arricchisce ogni lavoratore con `_cessato` precalcolato, usato dal
 * template `shared-lavoratori-risultati` per il badge globale "Cessato".
 */
export function withCessatoInfo<T extends { posizioni?: Record<string, PosizioneRaw> }>(
  lavoratori: T[],
): (T & { _cessato: CessatoInfo | null })[] {
  return lavoratori.map(l => ({ ...l, _cessato: buildCessatoInfo(l.posizioni) }));
}
